<template>
  <div>
    <div class="head-box">
      <div class="c-flex c_flex_center">
        <h4>结算明细</h4>
      </div>
      <div class="c-flex c-flex-item">
        <el-input
          placeholder="请输入标题/简介"
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <!-- <el-button type="primary" @click="doNew" class="c-m-l-10">新增结算明细</el-button> -->
        <el-button
          type="primary"
          class="c-m-l-10"
          @click="
            osg.doExport(
              {
                'is:state|integer#and': state == 'all' ? null : 1,
                'fpi-regex:name|string#or': searchValue,
                'fpi-regex:phone|string#or': searchValue,
                'fpi-regex:otherPhone|string#or': searchValue,
                'fpi-regex:address|string#or': searchValue,
                'fpi-regex:_id|string#or': searchValue,
                beanName: 'settleItem',
                title: '结算明细'
              },
              { dynamic: true }
            )
          "
        >
          数据导出
        </el-button>
        <el-popover width="200" popper-class="c-popper" @show="osg.colSetShow">
          <div
            v-if="osg.customize.entity.entityID == osg.customize.entity.tenantId"
            style="border-bottom: 1px solid #DCDFE6;margin-bottom: 12px;"
          >
            <div>
              <i class="el-icon-s-tools c-m-r-5"></i>
              <span>应用范围：</span>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-model="osg.customize.bizType"
                @change="osg.customizeBizTypeChange"
                placeholder="请选择 个人/组织/角色"
                size="small"
                style="width:100%"
              >
                <el-option
                  v-for="item in osg.options.bizType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-if="osg.customize.bizType == 0"
                v-model="osg.customize.bizId"
                :remote-method="osg.getUsers"
                filterable
                remote
                placeholder="可搜索人员姓名/手机/组织"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.users"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
              <el-cascader
                v-if="osg.customize.bizType == 1"
                v-model="osg.customize.bizId"
                :options="osg.options.orgs"
                :props="{
                  checkStrictly: true,
                  emitPath: false,
                  label: 'orgName',
                  value: '_id',
                  children: 'orgList'
                }"
                size="small"
                style="width:100%"
                placeholder="请选择组织"
              ></el-cascader>
              <el-select
                v-if="osg.customize.bizType == 2"
                v-model="osg.customize.bizId"
                placeholder="请选择角色"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.roles"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="c-popper-header">
            <i class="el-icon-info c-blue c-m-r-5"></i>
            <span>拖拽字段进行排序</span>
          </div>
          <div class="c-popper-content">
            <draggable v-model="extFields" @end="osg.listRefresh">
              <transition-group>
                <template v-for="(f, i) in extFields">
                  <div
                    v-if="f.showList && f.showList.indexOf('1') != -1"
                    :key="i"
                    class="c-popper-row"
                  >
                    <el-switch
                      v-model="f.customizeFlag"
                      :active-value="1"
                      :inactive-value="0"
                      @change="osg.listRefresh"
                    ></el-switch>
                    <span>{{ f.nameDisp }}</span>
                  </div>
                </template>
              </transition-group>
            </draggable>
          </div>
          <div class="c-popper-footer">
            <el-button type="primary" size="mini" @click="osg.saveConfig()">保存</el-button>
            <el-button type="text" size="mini" @click="osg.listReset">重置</el-button>
          </div>
          <i slot="reference" class="el-icon-s-operation c_size_20 c-blue c-m-l-10 c-pointer"></i>
        </el-popover>
      </div>
    </div>
    <div class="content-box">
      <div class="content-filter">
        <c-filter></c-filter>
      </div>
      <div class="content-table">
        <el-table
          ref="table"
          height="calc(100% - 50px)"
          :data="fpi.data"
          highlight-current-row
          border
          @header-dragend="osg.colWidthChange"
        >
          <c-table :fields="extFields">
            <template slot="rules">
              <el-table-column label="结算政策" width="800px">
                <template slot-scope="scope" v-if="scope.row.rules.length > 0">
                  <el-table :data="scope.row.rules">
                    <el-table-column
                      prop="settleRule.name"
                      label="政策名称"
                      show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                      prop="settleRule.currentDeductType"
                      :formatter="formatDeductType"
                      label="扣减科目"
                      show-overflow-tooltip
                    ></el-table-column>
                    <!-- <el-table-column prop="cardinal" label="基数金额(元)"></el-table-column> -->
                    <el-table-column
                      prop="amountDeduct"
                      label="实际平台服务费"
                      show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column label="结算数值" show-overflow-tooltip>
                      <template slot-scope="scope2">
                        {{ scope2.row.settleRule.currentCalcTypeValue }}
                        {{ scope2.row.settleRule.currentCalcType == 0 ? '%' : '元' }}
                      </template>
                    </el-table-column>
                  </el-table>
                </template>
              </el-table-column>
            </template>
          </c-table>
          <el-table-column fixed="right" width="100" label="操作">
            <template slot-scope="scope">
              <el-dropdown>
                <el-button>
                  操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="getLog(scope.row._id)">
                    查看日志
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="
                      osg.has('SettleItem,unfreeze') &&
                        scope.row.state == 1 &&
                        scope.row.tradeIn == 1 &&
                        scope.row.settleItemState == 0 &&
                        !scope.row.exts.fzOrderId
                    "
                    @click.native="unfreeze(scope.row._id)"
                  >
                    解冻付款
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog title="新增结算明细" :visible.sync="openDetail">
      <c-form
        :formData="formData"
        :fields="extFields"
        :area="area"
        :upload="upload"
        :options="options"
        ref="form"
        labelWidth="150px"
        @changeForm="osg.changeForm"
      ></c-form>
      <div slot="footer">
        <el-button type="primary" @click="doSave">确 定</el-button>
        <el-button @click="doInit">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog title="结算明细日志" :visible.sync="log.show" width="1000px">
      <el-table
        ref="logTable"
        height="calc(100% - 50px)"
        :data="log.fpi.data"
        highlight-current-row
        border
        class="c-table-border"
      >
        <el-table-column label="标题" prop="title"></el-table-column>
        <el-table-column label="内容" prop="content"></el-table-column>
        <el-table-column label="操作人" prop="upsetUserName"></el-table-column>
        <el-table-column label="创建时间" prop="createTime"></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
export default {
  activated() {
    window.$this = this;
  },
  name: 'settleItem',
  data() {
    window.$this = this;
    return {
      name: 'settleItem',
      fpi: {},
      searchValue: '',
      openDetail: false,
      formData: {
        images: [],
        videos: []
      },
      extFields: [],
      extField: {}, //特殊字段类型 如rate值为number类型,checkbox值为数组不能为空
      rules: this.$util.rules,
      options: {
        codecfg_deductType: { codeId: 'deductType' }
      },
      area: {
        options: this.osg.areaList,
        props: {
          checkStrictly: true,
          expandTrigger: 'hover'
        }
      },
      upload: {
        url: 'http://up-z1.qiniup.com',
        downloadUrl: this.osg.downloadUrl,
        data: {},
        dialogImageUrl: '',
        dialogVisible: false
      },
      log: {
        show: false,
        fpi: {
          data: []
        }
      }
    };
  },
  mounted() {
    this.doInit();
    this.osg.getFields('settleItem', () => {
      this.osg.getFpi();
      this.getData();
    });
  },
  methods: {
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getData();
    },
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getData();
    },
    doInit() {
      this.openDetail = false;
      this.formData = { images: [], videos: [], exts: {} };
      if (this.$refs.formData) this.$refs.formData.resetFields();
      this.$util.renderExtField(this.extFields, this.formData);
    },
    getData() {
      var params = {
        page: this.fpi.page || 1,
        rows: this.fpi.rows || 20,
        'in:state|array-integer#and': '0,1',
        sortField: 'createTime',
        sortOrder: 'desc',
        'regex:contactsName|string#or': this.searchValue,
        'regex:contactsPhone|string#or': this.searchValue,
        'regex:num|string#or': this.searchValue,
        'regex:contractdocNum|string#or': this.searchValue,
        'regex:partyB|string#or': this.searchValue,
        'regex:address|string#or': this.searchValue
      };
      window.$that.getParams(params);
      this.osg.setFpi(params);
      this.osg.ajax('biz/settleItem/query.do', params, res => {
        this.fpi = res;
        this.$nextTick(() => {
          this.$refs.table.doLayout();
          this.$forceUpdate();
        });
      });
    },
    doNew() {
      this.doInit();
      this.openDetail = true;
      this.$nextTick(() => {
        if (this.$refs.form && this.$refs.form.$refs.formData) {
          this.$refs.form.$refs.formData.clearValidate();
        }
      });
    },
    doSave() {
      if (this.osg.validate()) {
        this.$util.saveFormatExtField(this.extFields, this.formData);
        this.osg.ajax('biz/settleItem/upsert.do', { data: JSON.stringify(this.formData) }, () => {
          this.doInit();
          this.getData();
          this.osg.toast('保存成功！');
        });
      }
    },
    getLog(id) {
      this.log.show = true;
      this.osg.ajax(
        'tenantLog/query.do',
        {
          sid: id,
          smodule: 'settleItem',
          sortField: 'createTime',
          sortOrder: 'desc',
          _all: '1'
        },
        res => {
          this.log.fpi = res;
        }
      );
    },
    doEdit(row) {
      row = this.$util.deepCopy(row);
      row.images = row.images || [];
      row.videos = row.videos || [];
      this.formData = row;
      this.openDetail = true;
      this.$forceUpdate();
    },
    doEnable(row) {
      this.osg.confirm(`是否确认上架“${row.name}”？`, () => {
        this.osg.ajax(`biz/settleItem/enable/${row._id}.do`, {}, () => {
          this.osg.toast('操作成功！');
          this.getData();
        });
      });
    },
    doDisable(row) {
      this.osg.confirm(`是否确认下架“${row.name}”？`, () => {
        this.osg.ajax(`biz/settleItem/disable/${row._id}.do`, { id: row._id }, () => {
          this.osg.toast('操作成功！');
          this.getData();
        });
      });
    },
    doRemove(row) {
      this.osg.confirm(`是否确认删除“${row.name}”？`, () => {
        this.osg.ajax(`biz/settleItem/remove/${row._id}.do`, { id: row._id }, () => {
          this.osg.toast('操作成功！');
          this.getData();
        });
      });
    },
    unfreeze(id) {
      this.osg.confirm('是否确认解冻此条明细付款？', () => {
        this.osg.ajax(`/biz/settleItem/unfreeze/${id}.do`, {}, () => {
          this.getData();
          this.osg.toast('解冻成功');
        });
      });
    },
    formatDeductType(row, column, cellValue) {
      return this.osg.codelabel('deductType', cellValue);
    }
  }
};
</script>
